import { ModalContainerContextProvider } from 'app/src/modals/ModalContainerContext';
import * as React from 'react';

type Props = {
	children: React.ReactNode;
};

export default function ModalController({ children }: Props): React.ReactElement {
	const [modalContainer, setModalContainer] = React.useState<HTMLDivElement | null>(null);
	const modalContainerRef = React.useRef<HTMLDivElement | null>(null);

	React.useEffect(() => {
		setModalContainer(modalContainerRef.current);
	}, []);

	return (
		<ModalContainerContextProvider value={modalContainer}>
			{children}
			<div ref={modalContainerRef} />
		</ModalContainerContextProvider>
	);
}
